import React from 'react';

const AgentMessages: React.FC = () => (
  <div className="max-w-7xl mx-auto px-4 py-8">
    <h1 className="text-2xl font-bold mb-6">Messages</h1>
    <p className="text-gray-600">Communicate with talents.</p>
  </div>
);

export default AgentMessages;
